import { render, staticRenderFns } from "./RechargeSocials.vue?vue&type=template&id=0119c83a"
import script from "./RechargeSocials.vue?vue&type=script&lang=js"
export * from "./RechargeSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports